 export  const validImageTypes=['image/jpg','image/png','image/gif','image/jpeg'];